(function() {
  "use strict";
  angular.module("marketPlace.payments", ["ngResource", "toastr"]);
})();
